// Ozow only sends back its own fields, so the result page cannot tell where a
// payment started. Payments started from the landing page remember that here,
// for the length of the tab, keyed by their transaction reference. Anything
// not remembered was started inside the app.
const STORAGE_KEY = "paymentReturn";

export const rememberPaymentReturn = (reference, details) => {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ reference, ...details })
    );
  } catch {
    // Without storage the result page falls back to the in-app behaviour.
  }
};

export const paymentReturnFor = (reference) => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    return reference && saved?.reference === reference ? saved : null;
  } catch {
    return null;
  }
};
